import { ActivateAccountScreen } from "@/features/auth/screens/ActivateAccountScreen";
import { verifyEmailOtpRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

const VerifyEmail = () => {
    const { email } = Route.useSearch();
    return <ActivateAccountScreen email={email} />;
};

export const Route = createFileRoute("/_auth/activate-account")({
    component: VerifyEmail,
    validateSearch: (search) => verifyEmailOtpRouteSearchSchema.parse(search),
    beforeLoad: async ({ context: { auth } }) => {
        return auth;
    },
});
